/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Modal from '@components/modal/Modal';
import { hideAlert } from '@/store/global';
import { isWeb } from '@global/screens';
import { Loader } from '@components/screen/Layout';

const Alert = () => {
  const dispatch = useDispatch();
  const showAlert = useSelector((state) => state.global.showAlert);

  const show = showAlert.show;
  const title = showAlert.title;
  const description = showAlert.description;
  const descriptionComponent = showAlert.descriptionComponent;
  const hideCancel = !showAlert.isConfirm;
  const others = showAlert.others;
  const internet = showAlert.internet;
  const testID = showAlert.testID || 'alert';

  const onCancel = () => {
    try {
      dispatch(hideAlert());
      if (hideCancel) {
        showAlert.onCallback();
      }
      if (showAlert.onCallbackCancel) {
        showAlert.onCallbackCancel();
      }
    } catch (error) {
      dispatch(hideAlert());
    }
  };

  const onOk = (val = null) => {
    dispatch(hideAlert());
    try {
      showAlert.onCallback();
    } catch (error) {}
  };

  return (
    <Modal
      testID={`${testID}-alert`}
      transparent={true}
      visible={show}
      animationType="fade"
      needTop={true}
      onClose={() => (internet ? false : onCancel())}>
      <View style={styles.alert}>
        <View style={styles.titleSpace}>
          <SociollaText
            testID={`${testID}-alert-title`}
            type="medium"
            style={styles.title}
            ellipsizeMode="tail"
            numberOfLines={isWeb ? 0 : 1}>
            {title}
          </SociollaText>
        </View>
        {description ? (
          <View style={styles.descriptionSpace}>
            {Array.isArray(description) ? (
              <>
                {description.map((item, idx) => (
                  <SociollaText
                    testID={`${testID}-alert-description-${idx}`}
                    style={[styles.description, styles.descriptionArray]}
                    key={idx}>
                    {item}
                  </SociollaText>
                ))}
              </>
            ) : (
              <SociollaText
                testID={`${testID}-alert-description`}
                style={styles.description}>
                {description}
              </SociollaText>
            )}
          </View>
        ) : (
          false
        )}
        {descriptionComponent ? (
          <View style={styles.descriptionSpace}>{descriptionComponent}</View>
        ) : (
          false
        )}
        <View style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
          {!hideCancel ? (
            <TouchableOpacity
              testID={`${testID}-alert-cancel-btn`}
              activeOpacity={0.6}
              style={styles.buttonCancel}
              onPress={() => onCancel()}>
              <SociollaText type="medium" style={styles.blueText}>
                CANCEL
              </SociollaText>
            </TouchableOpacity>
          ) : (
            false
          )}
          {internet ? (
            <Loader />
          ) : (
            <TouchableOpacity
              testID={`${testID}-alert-ok-btn`}
              activeOpacity={0.6}
              onPress={() => onOk()}>
              <SociollaText type="medium" style={styles.confirmText}>
                OK
              </SociollaText>
            </TouchableOpacity>
          )}
        </View>
        {others ? (
          <View style={styles.others}>
            <TouchableOpacity
              testID={`${testID}-alert-others-btn`}
              activeOpacity={0.6}
              onPress={() => onOk('others')}>
              <SociollaText type="medium" style={styles.blueText}>
                {others}
              </SociollaText>
            </TouchableOpacity>
          </View>
        ) : (
          false
        )}
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  alert: {
    position: 'absolute',
    top: 200,
    backgroundColor: Colors.white,
    width: 250,
    alignSelf: 'center',
    borderRadius: 3,
    paddingTop: 25,
    paddingBottom: 20,
    paddingHorizontal: 20,
  },
  title: { fontSize: 14, width: 210 },
  titleSpace: { marginBottom: 15 },
  description: { fontSize: 12, lineHeight: 18 },
  descriptionSpace: { marginBottom: 30 },
  descriptionArray: { marginBottom: 5 },
  buttonCancel: { marginRight: 20 },
  confirmText: { color: Colors.blue0 },
  blueText: { color: Colors.blue1 },
  others: { alignItems: 'flex-end', marginTop: 15 },
});

export default Alert;
